import React, { useEffect } from "react";
import { clearAuthState } from "../utils/authUtils";

const AuthGuard = ({ children }) => {
  useEffect(() => {
    // Check if we're on an AWS Cognito hosted UI page and redirect immediately
    const isOnAWSPage =
      window.location.href.includes("signin.aws.amazon.com") ||
      window.location.href.includes("cognito") ||
      window.location.href.includes("amazonaws.com");

    if (isOnAWSPage) {
      console.log(
        "AuthGuard - Detected AWS Cognito page, redirecting to custom login"
      );
      clearAuthState();
      window.location.replace("/login");
      return;
    }
  }, []);

  return children;
};

export default AuthGuard;
